import { ChangeDetectorRef, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@core/services/translate.service';
import { Subscription } from 'rxjs';

@Pipe({
  name: 'translate',
  pure: false
})
export class TranslatePipe implements PipeTransform, OnDestroy {
  private languageSub: Subscription;

  constructor(
    private translateService: TranslateService,
    private cdr: ChangeDetectorRef
  ) {
    this.languageSub = this.translateService.getCurrentLanguage$().subscribe(() => {
      this.cdr.markForCheck();
    });
  }

  transform(key: string, params?: any): string {
    return this.translateService.translate(key, params);
  }

  ngOnDestroy(): void {
    this.languageSub.unsubscribe();
  }
}
